import { ref } from 'vue'

import { requestGeoPoint } from '@/composables/useGeolocation'
import type { LngLat } from '@/composables/useLocation'
import { useToastStore } from '@/stores/toast'
import { t } from '@/i18n'

/**
 * Кнопки «найти меня» и «показать ближайшие»: спрашивают координаты
 * и объясняют отказ. Молчащая кнопка выглядит сломанной, поэтому
 * про запрещённый доступ говорим отдельно — окна второй раз не будет,
 * и клиенту надо знать почему.
 */
export function useGeoPoint() {
  const $toast = useToastStore()

  const isLocating = ref(false)

  async function locate(): Promise<LngLat | null> {
    isLocating.value = true
    const result = await requestGeoPoint()
    isLocating.value = false

    if (result.point) return result.point

    $toast.warning(
      result.status === 'blocked'
        ? t('errors.geoDenied')
        : t('errors.geoFailed'),
    )
    return null
  }

  return { isLocating, locate }
}
